import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import ExitToApp from "@material-ui/icons/ExitToApp";

// core components
import Button from "components/CustomButtons/Button.jsx";
import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";

import { logOut } from '../../assets/helpers/loginHelper.jsx';

class HeaderLinks extends React.Component {
  state = {
    open: false
  };

  handleLogout = event => {
    logOut()
    window.location.reload();
  }
  render() {
    const { classes, rtlActive } = this.props;
    const wrapper = classNames({
      [classes.wrapperRTL]: rtlActive
    });
    return (
      <div className={wrapper}>

        <Button
          color="transparent"
          aria-label="Log out"
          className={classes.buttonLink}
          onClick={this.handleLogout}
          id="logOutButton"
        >
          log out
          <ExitToApp
            className={
              classes.headerLinksSvg +
              " " +
              (rtlActive
                ? classes.links + " " + classes.linksRTL
                : classes.links)
            }
          />
        </Button>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool
};

export default withStyles(headerLinksStyle)(HeaderLinks);
